globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCreateCustomerNeedDetection = (function(superClass)
{
  utils.extend(ModalCreateCustomerNeedDetection, superClass);

  function ModalCreateCustomerNeedDetection($html) {
      return ModalCreateCustomerNeedDetection.__super__.constructor.apply(this, arguments);
  }

  $.extend(ModalCreateCustomerNeedDetection.prototype, {
    init: function()
    {
      this.$html.find('textarea.ck-editor').each(function(){
        var $textarea = $(this);

        utils.require([assets.ckeditor], function() {
          var targetId = $textarea.attr('id'),
              editorParams = {
                startupFocus: false,
                enterMode : CKEDITOR.ENTER_BR,
                height: 100,
                skin: 'moono-lisa',
                removePlugins: 'font',
                extraPlugins: '',
              };

          if($textarea.data('allowed-content') != undefined) {
            editorParams["allowedContent"] = $textarea.data('allowed-content')
          }

          var editor = CKEDITOR.replace(targetId, editorParams);
          editor.on('instanceReady', function(ev){
            ev.editor.dataProcessor.writer.setRules('br', {
              indent : false,
              breakBeforeOpen : false,
              breakAfterOpen : false,
              breakBeforeClose : false,
              breakAfterClose : false
            });
          });

          editor.on('change', function(){
            var $input = $textarea.closest('.form-group textarea');
            $input.val(this.getData());
          })
        });
      });

      this.$html.find('.datepicker').each(function() {
        var $datePicker = $(this);

        $datePicker.daterangepicker(
          {
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: false,
            autoUpdateInput: false,
            locale: {
                format: 'DD/MM/YYYY'
            },
            startupFocus: false,
          },
          function(start, end, label) {
            $datePicker.val(start._d.toLocaleDateString());
          }
        );
      });

      backoffice.initSelect2(this.$html.find('.select'));
      backoffice.initSelect2Search(this.$html.find('.select-search'));

      ModalCreateCustomerNeedDetection.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data) {
      if(data.response) {
        new PNotify({icon: 'icon-checkmark3', title: "Détection de besoin créée", type: 'success'});
      } else {
        new PNotify({icon: 'icon-cross2', title: "Erreur de création", type: 'error'});
      }

      ModalCreateCustomerNeedDetection.__super__.callbackSuccess.apply(this, arguments);
    }
  });

  return ModalCreateCustomerNeedDetection;
})(backoffice.ModalMain);
